import { addonMaxAmount } from "../../utils/addonUtils";

type PlanVariantAddonLike = {
  id?: string;
  disabled?: boolean;
  quantity_step?: number;
  max_amount?: Record<string, number>;
  [key: string]: unknown;
};

type PlanVariantLike = {
  name?: unknown;
  assets?: number;
  [key: string]: unknown;
};

export type AddonBounds = {
  min: number;
  max: number;
  step: number;
  disabled: boolean;
};

/**
 * Compute per-addon UI bounds for the upgrade-request form:
 *   min      — floor for the request, taken from the caller-supplied
 *              `currentBookedQuantity` (nullish → 0). Legacy /upgrade passes
 *              the booked quantity ("can't ask for less than you have"); the
 *              SF request flow passes `null` so users can signal a downgrade.
 *   max      — caller-side cap resolved via `addonMaxAmount` (per-plan asset
 *              cap for connected-asset / HBV, hardcoded 1 for opc-ua-server /
 *              liquiline-assist, per-plan `max_amount` overrides, else 999)
 *   step     — quantity increment, defaulting to 1
 *   disabled — dim the whole row when true (`addon.disabled`)
 */
export function addonBounds(
  addon: PlanVariantAddonLike,
  planVariant: PlanVariantLike,
  currentBookedQuantity?: number | null,
): AddonBounds {
  return {
    min: Math.max(0, currentBookedQuantity ?? 0),
    max: addonMaxAmount(addon, planVariant),
    step: addon.quantity_step ?? 1,
    disabled: addon.disabled ?? false,
  };
}
